import api from "@/config/api";

const path = "private/formular/employee/docket"

export default {
  getById: (id) => {
    return api.get(`${path}/${id}`, { withCredentials: true })
  },
  getEmpty: () => {
    return api.get(`${path}`, { withCredentials: true })
  }
}
